// extracted by mini-css-extract-plugin
export default {"render":"RenderImageButton_render__7ibSE"};